import React from 'react'
import ServiceSection from './service-section'
import { ServicesContainer } from './styles'

const ServiceCardList = ({ services, selectedMarket, showServiceInfo, showOnlyBookButton = false }) => {
  return (
    <ServicesContainer className="services-container">
      <div className="content-wrapper">
        {Object.keys(services).map((serviceType) => (
          <ServiceSection
            serviceType={serviceType}
            market={selectedMarket}
            key={serviceType}
            services={services[serviceType]}
            showServiceInfo={showServiceInfo}
            showOnlyBookButton={showOnlyBookButton}
          />
        ))}
      </div>
    </ServicesContainer>
  )
}

export default ServiceCardList
